var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 60,
    viewBox: "0 0 240 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1977_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9359 19.6588V46.202H77.26V19.6588V18.6353H78.2853H87.4552V13.8364H60.7119V18.6353H69.9106H70.9359V19.6588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.024 41.4322H129.358H128.332V40.399V33.4566V32.4235H129.358H140.847V27.5957H129.358H128.332V26.5625V19.6201V18.587H129.358H145.024V13.7495H122.037V46.2407H145.024V41.4322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.326 32.1435L153.753 13.8364H147.247L164.255 45.8255L181.34 13.8364H174.738L165.137 32.1435L164.226 33.8718L163.326 32.1435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.411 40.399V33.4566V32.4235H192.436H203.925V27.5957H192.436H191.411V26.5625V19.6201V18.587H192.436H208.093V13.7495H185.115V46.2407H208.093V41.4322H192.436H191.411V40.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.818 29.9999L229.221 29.4109L240 13.8364H232.91L226.116 23.6272L225.273 24.8342L224.439 23.6272L217.655 13.8364H210.574L221.296 29.4109L221.708 29.9999L221.296 30.5889L210.564 46.1827L217.655 46.202L224.43 36.3726L225.273 35.156L226.116 36.3726L232.919 46.202H240L229.221 30.5889L228.818 29.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.031 33.7753C112.254 33.0511 113.222 32.4331 114.544 30.8979C116.144 29.0247 116.92 27.1032 116.92 25.0176V24.1197C116.92 20.7402 115.694 19.0987 113.279 17.1C110.711 14.9951 107.08 13.8364 103.065 13.8364H90.541L90.5698 46.202H96.8651V30.193H96.8364V18.6256H102.547C104.904 18.6256 107.118 19.2339 108.335 20.2188H108.354L108.364 20.2381C109.695 21.3968 110.366 22.7679 110.366 24.3321C110.366 27.5764 107.444 30.2124 103.86 30.2124H100.056V30.193H97.7754L98.6953 31.3614L110.309 46.1924H117.907L109.542 35.3878L108.641 34.2291L110.031 33.7753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8568 40.7371H27.4717V59.9904L54.9241 32.3271C45.8499 31.1877 37.6382 30.6953 30.3846 30.6084L32.8568 40.7275V40.7371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27.6826C5.47131 28.6772 13.8268 29.7683 24.7215 29.9614L24.8557 29.4207C23.2076 28.4937 22.0865 26.7171 22.0865 24.6798C22.0865 21.6865 24.5011 19.2533 27.4716 19.2533V0",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4717 60V40.7467H22.0866L24.5588 30.647C14.0761 30.8401 5.96015 31.8732 0.517578 32.8388L18.1868 39.3756L27.4813 60.0097L27.4717 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8568 24.6894C32.8568 26.7267 31.7452 28.5034 30.0876 29.4303L30.2217 29.9903C37.6573 29.9131 46.0991 29.4014 55.4511 28.2041L36.7566 20.6341L27.4717 0V19.263C30.4421 19.263 32.8568 21.6962 32.8568 24.6894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4607 28.2041L27.4717 0L36.7662 20.6341L55.4607 28.2041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4607 28.2041L27.4717 0L36.7662 20.6341L55.4607 28.2041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.177 39.366L0.507812 32.8291L27.4715 60L18.177 39.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.177 39.366L0.507812 32.8291L27.4715 60L18.177 39.366Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1977_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.c233750b46dcf6018d939a53e2033343.svg";
export { ForwardRef as ReactComponent };